import { Tooltip } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import React from 'react';
/** Circled "i" that shows help copy on hover/focus (MUI Tooltip, so never clipped). */
export const InfoDot = ({ info }) => (React.createElement(Tooltip, { arrow: true, title: info },
    React.createElement("span", { 
        // Stop clicks reaching an enclosing <label> (e.g. a Toggle's switch).
        onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
        }, style: { cursor: 'help', display: 'inline-flex' }, tabIndex: 0 },
        React.createElement(InfoOutlined, { color: "primary", style: { fontSize: 16 } }))));
